import React, { useState } from "react";
import "./AssignPopup.css";
import close from "../../Assets/close.svg";

const AssignPopup = ({
  isOpen,
  onClose,
  onAssign,
  armUsers = [],
}) => {
  const [selectedUser, setSelectedUser] = useState("");

  const filteredUsers = armUsers;
  const assignLabel = "ARM";

  const handleAssign = (action) => {
    onAssign(selectedUser, action);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="assign-popup-overlay">
      <div className="assign-popup">
        <div className="assign-popup-header">
          <h3 className="assign-title">Assign Application</h3>
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="" />
          </button>
        </div>

        <div className="assign-content">
          <h4 className="choose-title">Assignment Option</h4>
          <div className="tl-options">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <label key={user._id} className="tl-option">
                  <input
                    type="radio"
                    name={assignLabel}
                    value={user._id}
                    checked={selectedUser === user._id}
                    onChange={(e) => setSelectedUser(e.target.value)}
                  />
                  <span className="radio-custom"></span>
                  {user.name}
                </label>
              ))
            ) : (
              <p
                style={{ textAlign: "center", color: "#666", padding: "20px" }}>
                No ARM users available
              </p>
            )}
          </div>
        </div>

        <div className="assign-actions">
          <button className="reject-btn" onClick={() => handleAssign("reject")}>
            Cancel
          </button>

          <button
            className="accept-btn"
            disabled={!selectedUser}
            onClick={() => handleAssign("assign")}>
            Assign
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignPopup;
